import React, { useCallback, useEffect, useMemo, useState } from "react"

import { isNil } from "ramda"

import { useStyles } from "./customization"
import { getLocalStorageValues, setLocalStorageValues } from "./lib"
import index18n from "../../../lib/i18n.es6"
import { MuiIcon } from "../../atoms"
import { Button } from "../../molecules"
import { Popover } from "../popover"

export const FilterButton = ({ position, render, setFilterState, setResetFilter, tableId }) => {
  const [isOpen, dialogTumbler] = useState(false)
  const { counterContainer, filterButtonContainer, filterPopover } = useStyles(isOpen)
  const [anchor, setAnchor] = useState(null)
  const [filterCounter, setFilterCounter] = useState(0)

  const onClick = (event) => {
    setAnchor(event.currentTarget)
    dialogTumbler(!isOpen)
  }

  const onClose = () => {
    dialogTumbler(false)
  }

  const [values, setValues] = useState({})

  useEffect(() => {
    setFilterCounter(
      Object.values(values || {}).filter((item) => !isNil(item) && item.toString().length).length,
    )
  }, [values])

  const handleChange = useCallback(
    (props) => {
      isOpen && setValues(props.values)
      setFilterState(props)
    },
    [isOpen, setValues],
  )

  useEffect(() => {
    const storageValues = getLocalStorageValues(tableId, "filters")

    const resetFilter = (initialValues = {}) => {
      setValues(initialValues)
      setFilterState(initialValues)
    }

    setResetFilter(resetFilter)

    render?.()?.props?.onChange?.({ values: storageValues })
    setValues({ ...storageValues })
    handleChange({ values: storageValues })
  }, [tableId])

  const handleReset = useCallback(
    (initialValues = {}) => {
      setValues(initialValues)
      setFilterState(initialValues)
      setLocalStorageValues(tableId, "filters", initialValues)
    },
    [setValues],
  )

  const popover = useMemo(
    () =>
      render({
        initialValues: values,
        isOpen,
        onChange: handleChange,
        onReset: handleReset,
        tableId,
      }),
    [isOpen, values, handleChange, handleReset, tableId],
  )

  return (
    <>
      <div className={filterButtonContainer}>
        <Button
          height={44}
          label={index18n("General.Filter:Filter")}
          variant="outlined"
          onClick={onClick}
          hoverStyle="never"
          startIcon={<MuiIcon.FilterList />}
          endIcon={!!filterCounter && <div className={counterContainer}>{filterCounter}</div>}
        />
      </div>
      <Popover
        className={filterPopover}
        anchor={anchor}
        content={popover}
        onClose={onClose}
        open={isOpen}
        title={index18n("General.Filter:Filter")}
        anchorOrigin={position.anchorOrigin}
        transformOrigin={position.transformOrigin}
      />
    </>
  )
}
